import React, { memo } from "react";
import { escapeRegExp } from "../../../utils/escapeReg";

interface HighlightTextProps {
    text: string;
    highlight: string;
  }
  
  const HighlightText: React.FC<HighlightTextProps> = memo(({ text, highlight }) => {
    const escapedHighlight = escapeRegExp(highlight);
    const parts = text.split(new RegExp(`(${escapedHighlight})`, "gi"));
    return (
      <span>
        {parts.map((part, i) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span key={i} style={{ backgroundColor: "yellow" }}>
              {part}
            </span>
          ) : (
            <span key={i}>{part}</span>
          )
        )}
      </span>
    );
  });

  export default HighlightText